import { useMemo } from 'react'
import { useTranslation } from '@front/model'

export type MultiSelectFilterToggleLabels = {
  toggleLabel: string
  toggleAriaLabel: string
}

export const useMultiSelectFilterToggleLabels = ({
  label,
  isSelected,
  doesToggleSelectAll,
}: {
  label: string
  isSelected: boolean
  doesToggleSelectAll: boolean
}): MultiSelectFilterToggleLabels => {
  const { t } = useTranslation()

  return useMemo(() => {
    if (doesToggleSelectAll) return { toggleLabel: t('Check all'), toggleAriaLabel: t('Check all options') }
    if (isSelected) return { toggleLabel: t('Uncheck'), toggleAriaLabel: t('Uncheck {{label}}', { label }) }
    return { toggleLabel: t('Check'), toggleAriaLabel: t('Check {{label}}', { label }) }
  }, [label, isSelected, doesToggleSelectAll, t])
}
